import {isNullOrUndefined} from "../../../services/Validator";

export default function CoursesContentLayout({children}) {
    // Used in CoursesScreen to frame screen content

    // BUILD
    if (isNullOrUndefined(children))
        return null;
    return (
        <div className={"w-[560px] md:w-[640px] lg:w-[800px] grow flex flex-col justify-start items-center"}>
            {children}
        </div>
    );
}